import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
const tables = ["hor", "trains", "trains_total"];
const tableHeadNew = [
  "Section",
  "Running TIme",
  "Speed",
  "No. of Train Run",
  "No. of Train Run (till date)",
  "Avg(till date)",
];
const sectionOrder = [
  "ET-JBP",
  "JBP-STA",
  "STA-MKP",
  "BINA-KTE",
  "KTE-SGRL",
  "STA-REWA",
  "REWA-SGRL",
  "JKE-JQSG",
];

const SpeedAvgMaster = ({ date, setLoading }) => {
  const [avgSpeed, setAvgSpeed] = useState(null);
  const [error, setError] = useState(null);
  const tableRef = useRef();
  const urlCrisPrefix = process.env.REACT_APP_URL_PREFIX_CRIS;

  const fetchApi = async (url) => {
    setLoading(true);
    try {
      const response = await axios.get(url);

      setAvgSpeed(response.data.data);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchApi(`${urlCrisPrefix}get_wc544_data?date=${date}`);
  }, [date]);
  // ///////////////////sorting
  avgSpeed &&
    avgSpeed?.current_date_data.sort(
      (a, b) => sectionOrder.indexOf(a.sctn) - sectionOrder.indexOf(b.sctn),
    );
  return (
    <div ref={tableRef}>
      <div className="table-responsive">
        <table
          className="table table-hover table-striped glassTable "
          style={{ fontSize: "12px" }}
        >
          <thead>
            <tr>
              {tableHeadNew.map((h, i) => {
                return <th key={i}>{h}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {avgSpeed?.current_date_data
              ?.filter((f) => f.sctn !== null)
              ?.map((o, k) => {
                return (
                  <tr key={k}>
                    <td>{o?.sctn}</td>
                    <td>{o?.hor}</td>
                    <td>{o?.speed}</td>
                    <td>{o?.trains}</td>
                    <td>{o?.trains_total}</td>
                    <td>
                      {(o?.trains_total / Number(date.slice(8, 10))).toFixed(2)}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>

      <div className="" style={{ maxHeight: "750px", overflow: "auto" }}>
        {/* {tables.map((t, i) => {
          return (
            <div key={i} className="table-responsive">
              <div className="bg-dark text-white">
                <b>
                  {t === "hor"
                    ? "Running Time"
                    : t === "trains"
                      ? "No. of Train Run"
                      : "Cumulative"}
                </b>
              </div>
              <table
                className="table table-hover table-striped newUiTable"
                style={{ fontSize: "12px" }}
              >
                <thead>
                  {t === "hor" ? (
                    <tr>
                      <th> Section</th>
                      <th>Running TIme</th>
                      <th>Speed</th>
                    </tr>
                  ) : t === "trains" ? (
                    <tr>
                      <th> Section</th>
                      <th>No. of Train Run</th>
                      <th>Speed</th>
                    </tr>
                  ) : (
                    <tr>
                      <th> Section</th>
                      <th>No. of Train Run</th>
                      <th>Avg</th>
                    </tr>
                  )}
                </thead>
                <tbody>
                  {avgSpeed &&
                    avgSpeed?.current_date_data
                      ?.filter((f) => f.sctn !== null)
                      .map((avd, k) => {
                        return t === "hor" ? (
                          <tr key={k}>
                            <td>{avd?.sctn}</td>
                            <td>{avd?.hor}</td>
                            <td>{avd?.speed}</td>
                          </tr>
                        ) : t === "trains" ? (
                          <tr key={k}>
                            <td>{avd?.sctn}</td>
                            <td>{avd?.trains}</td>
                            <td>{avd?.speed}</td>
                          </tr>
                        ) : (
                          <tr key={k}>
                            <td>{avd?.sctn}</td>
                            <td>{avd?.trains_total}</td>
                            <td>
                              {(
                                avd?.trains_total / Number(date.slice(8, 10))
                              ).toFixed(2)}
                            </td>
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            </div>
          );
        })} */}
        <table className="table table-hover table-striped glassTable ">
          <thead>
            <tr>
              <th rowSpan={2} className="align-middle">
                JBP DIV. AVG. Speed
              </th>
              <th>Daily</th>
              <th>
                {avgSpeed &&
                  avgSpeed.current_date_data.filter((f) => f.sctn === null)[0]
                    ?.speed}
              </th>
              <th>PROG.</th>
              <th>
                {avgSpeed &&
                  avgSpeed.current_date_data.filter((f) => f.sctn === null)[0]
                    ?.speed_average}
              </th>
            </tr>
            {/* <tr>
              <th>PROG.</th>
              <th>
                {avgSpeed &&
                  avgSpeed.current_date_data.filter((f) => f.sctn === null)[0]
                    ?.speed_average}
              </th>
            </tr> */}
          </thead>
        </table>
      </div>
      <div className="m-1">
        <DownloadExcel
          tableRef={tableRef}
          fileName={`chc report train and running time `}
        />
      </div>
    </div>
  );
};
export default SpeedAvgMaster;
